import { ClientLambdaApi } from '@/api-client.js'

const login = async (email, password) => {
  const authResponse = await ClientLambdaApi.post('/api-token-auth/',
    {
      email: email,
      password: password
    })
  return authResponse.data
}

const getGoogleOAuthUrl = async () => {
  // Determine redirect URI based on environment
  const isProduction = process.env.NODE_ENV === 'production'

  let redirectUri
  if (isProduction) {
    // Production URL - adjust this to your actual production domain
    redirectUri = `${window.location.origin}/auth/google-callback`
  } else {
    // Development URL
    redirectUri = `${window.location.origin}/auth/google-callback`
  }

  const oauthResponse = await ClientLambdaApi.post('google-oauth/auth-url', {
    redirect_uri: redirectUri,
    state: Math.random().toString(36).substring(2, 15), // Generate random state for CSRF protection
    scopes: ['openid', 'email', 'profile']
  })
  return oauthResponse.data
}

const requestPassword = async (email) => {
  const resetPasswordResponse = await ClientLambdaApi.get(`/request-new-password/${email}`)
  return resetPasswordResponse.data
}

const putPassword = async (password, token) => {
  const updatePasswordResponse = await ClientLambdaApi.put('/update-password/',
    {
      token,
      password
    })
  return updatePasswordResponse.data
}

const updateRegion = async (regionId) => {
  const updateRegionResponse = await ClientLambdaApi.put(`/selected-region/${regionId}`)
  return updateRegionResponse.data
}

const googleOAuthTokenValidation = async (authorizationCode) => {
  // Determine redirect URI based on environment (same logic as getGoogleOAuthUrl)
  const isProduction = process.env.NODE_ENV === 'production'
  let redirectUri
  if (isProduction) {
    redirectUri = `${window.location.origin}/auth/google-callback`
  } else {
    redirectUri = `${window.location.origin}/auth/google-callback`
  }

  const authResponse = await ClientLambdaApi.post('/google-oauth', {
    code: authorizationCode,
    redirect_uri: redirectUri,
    device: 'desktop'
  })
  return authResponse.data
}

const getMicrosoftOAuthUrl = async () => {
  // Determine redirect URI based on environment
  const isProduction = process.env.NODE_ENV === 'production'

  let redirectUri
  if (isProduction) {
    // Production URL - adjust this to your actual production domain
    redirectUri = `${window.location.origin}/auth/microsoft-callback`
  } else {
    // Development URL
    redirectUri = `${window.location.origin}/auth/microsoft-callback`
  }

  const oauthResponse = await ClientLambdaApi.post('microsoft-oauth/auth-url', {
    redirect_uri: redirectUri,
    state: Math.random().toString(36).substring(2, 15) // Generate random state for CSRF protection
  })
  return oauthResponse.data
}

const microsoftOAuthTokenValidation = async (authorizationCode) => {
  // Determine redirect URI based on environment (same logic as getMicrosoftOAuthUrl)
  const isProduction = process.env.NODE_ENV === 'production'
  let redirectUri
  if (isProduction) {
    redirectUri = `${window.location.origin}/auth/microsoft-callback`
  } else {
    redirectUri = `${window.location.origin}/auth/microsoft-callback`
  }

  const authResponse = await ClientLambdaApi.post('/microsoft-oauth', {
    code: authorizationCode,
    redirect_uri: redirectUri,
    device: 'desktop'
  })
  return authResponse.data
}

const logout = async () => {
  const logoutResponse = await ClientLambdaApi.post('/api-token-logout/')
  return logoutResponse.data
}

export { login, getGoogleOAuthUrl, googleOAuthTokenValidation, getMicrosoftOAuthUrl, microsoftOAuthTokenValidation, requestPassword, putPassword, updateRegion, logout }



// WEBPACK FOOTER //
// ./src/app/authentication/Services.js